export const SearchCategory = {
  NAVIGATION: 'NAVIGATION',
  FIELDS: 'FIELDS',
  ACTIONS: 'ACTIONS',
  RECORDS: 'RECORDS',
  DOCUMENTS: 'DOCUMENTS',
  CONDITIONS: 'CONDITIONS',
  CONTACTS: 'CONTACTS',
};

export const SEARCH_CATEGORY_LABELS = {
  [SearchCategory.NAVIGATION]: 'Navigation',
  [SearchCategory.FIELDS]: 'Fields',
  [SearchCategory.ACTIONS]: 'Loan Actions',
  [SearchCategory.RECORDS]: 'Records',
  [SearchCategory.DOCUMENTS]: 'Documents',
  [SearchCategory.CONDITIONS]: 'Conditions & Tasks',
  [SearchCategory.CONTACTS]: 'Contacts',
};

export const LOAN_ACTION_TRIGGER_EVENT = 'universal-search:trigger-loan-action';

export const MAX_RESULTS_PER_CATEGORY = 5;

export const MAX_SUGGESTED_PER_CATEGORY = 2;

export const MAX_QUICK_ACTIONS_PER_TAB = 8;

export const SEARCH_INPUT_PLACEHOLDER =
  'Search fields, sections, records, conditions, contacts... Type / for actions';

export const SLASH_COMMAND_PREFIX = '/';

export const MAX_RECENT_SEARCHES = 5;

export const RECENT_SEARCHES_STORAGE_KEY = 'universal-search-recent';

export const SEARCH_DEBOUNCE_DELAY_MS = 150;

export const PULSE_HIGHLIGHT_DURATION_MS = 2_000;

export const POLL_INTERVAL_MS = 100;

export const POLL_MAX_ATTEMPTS = 50;

export const DOM_SETTLE_QUIET_MS = 300;

export const DOM_SETTLE_TIMEOUT_MS = 5_000;

export const PALETTE_WIDTH = 600;

export const PALETTE_MAX_HEIGHT = 480;
